<section>
    <ng-container *ngIf="certificateList?.length">
        <div>
            <p-table
                [value]="certificateList"
                [scrollable]="true"
                scrollHeight="flex"
                scrollDirection="both"
                selectionMode="single"
                (onRowSelect)="onRowSelect($event)"
                (onRowUnselect)="onRowUnselect()"
                dataKey="_cadesCertificate.objid">
                <ng-template pTemplate="header">
                    <tr>
                        <th></th>
                        <th i18n>Владелец сертификата</th>
                        <th i18n>Кому выдан</th>
                        <th i18n>Кем выдан</th>
                        <th i18n>Срок действия</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr [pSelectableRow]="item" [class.expanded-item]="expanded">
                        <td>
                            <button type="button" pButton pRipple [pRowToggler]="item" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                        </td>
                        <td>{{ checkSubjectName(item.subjectName, ['SN', 'G'], item.name) }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ checkIssueName(item.issuerName) }}</td>
                        <td>{{ item.validFrom | date:"dd.MM.yyyy" }} - {{ item.validTo | date:"dd.MM.yyyy" }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-item>
                    <tr class="expansion-row" [class.select-item]="selectedCertificate">
                        <td></td>
                        <td></td>
                        <td class="join-field">
                            <span>{{ handleStr(item.subjectName) }}</span>
                            <span>
                                <span i18n class="join-field-label">Отпечаток:</span>
                                {{ item.thumbprint }}
                            </span>
                        </td>
                        <td>{{ handleStr(item.issuerName) }}</td>
                        <td></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-container>
    <footer>
        <button i18n appSkin="action-save" (click)="close(selectedCertificate)" [disabled]="!selectedCertificate">Выбрать</button>
        <button i18n appSkin="simple-cancel" (click)="close()">Отмена</button>
    </footer>
</section>
